import { createMutationAtom } from 'atoms/create-resource-atom';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { DEFAULT_PAGE_SIZE } from 'lib/ui';
import {
  LandingAnalysisCountsResponse,
  LandingAnalysisDefaultParametersResponse,
  StructureGridCollectionCreateResponse,
  StructureGridCollectionUpdateResponse,
  StructureGridCollectionValidityResponse,
  StructureGridCollectionsQueryListResponse,
  StructureGridQueryResponse,
  WellLandingAnalysisExportResponse,
  WellLandingAnalysisJobsQueryResponse,
  WellLandingAnalysisRequestResponse,
  WellLandingAnalysisWellsQueryResponse,
  WellLandingPreviewResponse,
} from 'types/api-responses';

export const gridSurfaceMapAtom = atom<
  Map<number, StructureGridQueryResponse[]>
>(new Map());

export const structureGridCollectionCreateAtom = createMutationAtom<
  StructureGridCollectionCreateResponse,
  'structureGridCollectionCreate'
>();

export const pageSizeAtom = atomWithStorage<number>(
  'structureGridCollectionsPageSize',
  DEFAULT_PAGE_SIZE,
  undefined,
  { getOnInit: true }
);

export const structureGridCollectionsQueryAtom = createMutationAtom<
  StructureGridCollectionsQueryListResponse,
  'structureGridCollectionsQuery'
>();

export const structureGridCollectionValidityAtom = createMutationAtom<
  StructureGridCollectionValidityResponse,
  'structureGridCollectionValidity'
>();

export const updateStructureGridCollectionAtom = createMutationAtom<
  StructureGridCollectionUpdateResponse,
  'structureGridCollectionUpdate'
>();

export const useWellLandingPreviewAtom = (href?: string) =>
  useMemo(() => createResourceAtom<WellLandingPreviewResponse>(href), [href]);

export const useWellLandingDefaultParametersAtom = (href?: string) =>
  useMemo(
    () => createResourceAtom<LandingAnalysisDefaultParametersResponse>(href),
    [href]
  );

export const enableAutoUpdateAtom = createMutationAtom<
  StructureGridCollectionUpdateResponse,
  'enableAutoUpdate'
>();

export const landingAnalysisCountsAtom = createMutationAtom<
  LandingAnalysisCountsResponse,
  'landingAnalysisCounts'
>();

export const triggerWellLandingAnalysisAtom = createMutationAtom<
  WellLandingAnalysisRequestResponse,
  'wellLandingAnalysisRequest'
>();

export const wellLandingAnalysisJobsQueryAtom = createMutationAtom<
  WellLandingAnalysisJobsQueryResponse,
  'wellLandingAnalysisJobsQuery'
>();

export const useWellLandingAnalysisWellsAtom = () =>
  useMemo(
    () =>
      createMutationAtom<
        WellLandingAnalysisWellsQueryResponse,
        'wellLandingAnalysisWellsQuery'
      >(),
    []
  );

export const wellLandingAnalysisExportAtom = createMutationAtom<
  WellLandingAnalysisExportResponse,
  'wellLandingAnalysisExport'
>();
